<template>
  <!-- :style="`width: calc(100% - ${getSideBarWidth()}); scroll-behavior: smooth`" -->
  <v-card
    class="taktplan"
    :style="`width: 100%; scroll-behavior: smooth`"
    color="color-1"
    ref="taktplan"
    id="taktplan"
    @mousemove="moveTaktareaStartMouseMove($event),
      moveTrainStartMouseMove($event),
      flexBarHeightMouseMove($event),
      moveTaktPlanMouseMove($event)"
    @mouseup="moveTaktareaStartMouseUp(),
      moveTrainStartMouseUp(),
      flexBarHeightMouseUp()"
    @mouseleave="moveTaktareaStartMouseUp(),
      moveTrainStartMouseUp(),
      flexBarHeightMouseUp()"
    @mousedown="moveTaktPlanMouseDown($event)"
    @touchmove="flexBarHeightMouseMove($event)"
    @touchend="flexBarHeightMouseUp()"
    @touchcancel="flexBarHeightMouseUp()"
    >

    <!-- Standard Dialog -->
    <transition
      name="zoom-translate"
      >
      <router-view name="standard_dialog"/>
    </transition>
    <!-- InfoBox-->
    <!-- <transition
      name="zoom-translate"
      >
      <router-view v-if="!isEditMode" name="info_box"></router-view>
    </transition> -->
    <!-- SideBar -->
    <transition
      name="sidebar-slide-up"
      >
      <!-- <router-view v-if="isEditMode || ($route.matched[2] && $route.matched[2].name === 'MilestonesSideBar')" name="side_bar"></router-view> -->
      <router-view name="side_bar"></router-view>
    </transition>
    <!-- Taktplan -->
    <v-container
      fluid
      class="pa-0"
      style="position: absolute"
      >
      <!-- FlexBar -->
      <FlexBar
        :project_length="isSpatialView?getProjectLength(project_id):getProjectLength(project_id)+1"
        header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px"
        :set_statistics_height="getStatisticsHeightVariables.set_statistics_height"
        >
        <!-- Header Columns Months -->
        <template #header-columns-months>
          <HeaderPlaceholder
            width="calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"
            height="26px"
            z_index="5"
            sticky_left="0px"
            >
            <template #right-middle>
            </template>
          </HeaderPlaceholder>
          <HeaderPlaceholder
            width="calc(var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom))"
            height="26px"
            z_index="4"
            sticky_left="calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"
            >
            <template #right-middle>
            </template>
          </HeaderPlaceholder>
          <HeaderPlaceholder
            :key="isSpatialView"
            v-if="!isSpatialView"
            width="calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom))"
            height="26px"
            z_index="3"
          />
          <HeaderColumnMonth
            z_index="3"
            v-for="month in getCalendar(project_id).months"
            :key="month.name"
            :duration="month.duration"
            >
            <!-- {{month.name}} -->
            <TText :value="`${$store.state.Ultra.months[month.integer]} {year}`" :value_props="{year: ` '${month.year.toString().substring(2,4)}`}"/>
          </HeaderColumnMonth>
          <HeaderColumnMonth
            v-if="getCalendar(project_id).months.length === 0"
            z_index="3"
            :duration="getProjectLength(project_id)"
          />
          <HeaderColumnMonth
            z_index="3"
            />
        </template>
        <!-- Header Columns -->
        <template #header-columns>
          <HeaderPlaceholder
            width="calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"
            height="calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom))"
            max_height="75px"
            z_index="4"
            sticky_left="0px"
            >
            <StandardSwitch
              :value="isSpatialView"
              @changeValue="
              isEditMode? leaveEditMode({project_id: project_id}):'',
              $route.name !== 'ProjectTaktPlan'?$router.push({name: 'ProjectTaktPlan'}):'',
              setSpatialView(!isSpatialView)
              "
              icon="home"
            />
          </HeaderPlaceholder>
          <!-- v-if="isSpatialView" -->
          <HeaderPlaceholder
            width="calc(var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom))"
            height="calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom))"
            max_height="75px"
            z_index="4"
            sticky_left="calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"
            style="overflow: hidden"
            >
            <v-btn
              small
              @click="toggleAllTrains()"
              >
              <v-icon>keyboard_arrow_down</v-icon> all
            </v-btn>
          </HeaderPlaceholder>
          <HeaderColumn
            v-if="!isSpatialView"
            z_index="3"
            >
            <v-btn
            v-if="isEditMode"
            @click="$router.push({
              name: 'EditCalendar'
            })"
            :class="is_show_side_bar? 'grey darken-2':''"
            icon
            >
              <v-icon>
                calendar_today
              </v-icon>
            </v-btn>
          </HeaderColumn>
          <template
            v-if="getCalendar(project_id).takt_times.length !== 0"
            >
            <HeaderColumn
              v-for="(takt_time, index) in getCalendar(project_id).takt_times"
              :key="`takttime${index}`"
              z_index="3"
              >
              <DateCircle
                @click.native="setShowCalendarWeeks(), setShowMilestones(false)"
                :value="isShowCalendarWeeks?takt_time.calendar_weeks:[takt_time.first_day_string, takt_time.last_day_string]"
              />
            </HeaderColumn>
          </template>
          <template v-else>
            <HeaderColumn
              v-for="(takt_time, index) in getProjectLength(project_id)"
              :key="`takttime${index}`"
              z_index="3"
              />
          </template>
          <HeaderColumn
            z_index="3"
            >
          </HeaderColumn>
        </template>
      </FlexBar>
      <template v-if="!isSpatialView">
      <!-- Train -->
        <TPMTrain
            v-for="(train, train_index) in getUObjects({type: 'trains', ids: project.trains})"
            :key="`train${train.id}`"
            :draggable_disabled="draggable_disabled"
            :project_id="project_id"
            :train="train"
            :train_index="train_index"
            :new_milestone="new_milestone"
            :milestone_selection="milestone_selection"
            :snackbar="snackbar"
            @toggleDraggable="draggable_disabled = $event"
        />
      </template>
      <!-- spatial structure -->
      <div v-else style="position: relative; height: 100%">
        <TaktTimeHighLighter
          v-if="getCurrentTaktIndex(project_id) !== false"
          :index="Math.abs(getCurrentTaktIndex(project_id))"
          header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px"
          z_index="2"
          />
        <TaktTimeHighLighter
          v-if="getCurrentTaktIndex(project_id) !== false &&
                getCurrentTaktIndex(project_id) >= 0"
          :index="getCurrentTaktIndex(project_id) + 1"
          header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px"
          z_index="2"
          />
        <div style="width: 248px">
        <ProjectStructureTreeTaktplan
          v-for="site in getUObjects({type: 'sites', ids: project.sites})"
          :key="`site${site.id}`"
          :parent="site"
          :child_elements="getChildElements({parent_type: 'sites', parent_id: site.id})"
          :sticky_left="0"
          :project_length="getProjectLength(project_id)"
          :project_taktplan_spatial_header_width="project_taktplan_spatial_header_width"
          :project_id="project_id"
          :parent_color_index="0"
          @parentClicked="updateUDObject({
              url: [
                {[$event.type]: $event.id}
              ],
              update: {
                closed: !$event.closed
              }
            })"
        />
      </div>
  </div>
    </v-container>
  </v-card>
</template>
<script>
// import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

import { ProjectMixin } from '@/mixins/Project.mixin.js'
import { TaktPlanMixin } from '@/mixins/TaktPlan.mixin.js'
import { TrainMixin } from '@/mixins/Train.mixin.js'
import { TWaggonMixin } from '@/mixins/TWaggon.mixin.js'
import { TaktAreaMixin } from '@/mixins/TaktArea.mixin.js'
import { TWorkPackageMixin } from '@/mixins/TWorkPackage.mixin.js'
import { FlexBarMixin } from '@/mixins/FlexBar.mixin.js'
import { SideBarMixin } from '@/mixins/SideBar.mixin.js'
import { InfoBoxMixin } from '@/mixins/InfoBox.mixin.js'
import { SwitchMixin } from '@/mixins/Switch.mixin.js'
import { MilestonesMixin } from '@/mixins/Milestones.mixin.js'


import StandardSwitch from '@/components/StandardComponents/StandardSwitch.component.vue';

import TPMTrain from '@/views/Project/ProjectTaktPlanMobile/TPMTrain.wrapper.vue';
import TaktTimeHighLighter from '@/components/ProjectTaktPlan/TaktTimeHighLighter.component.vue'
import HeaderColumn from '@/components/ProjectTaktPlan/HeaderColumn.component.vue'
import HeaderColumnMonth from '@/components/ProjectTaktPlan/HeaderColumnMonth.component.vue'
import HeaderPlaceholder from '@/components/ProjectTaktPlan/HeaderPlaceholder.component.vue'
import DateCircle from '@/components/ProjectTaktPlan/DateCircle.component.vue'
import FlexBar from '@/components/ProjectTaktPlan/FlexBar.component.vue'

// @ is an alias to /src

export default {
  components: {
    TPMTrain,
    TaktTimeHighLighter,
    HeaderColumn,
    HeaderColumnMonth,
    HeaderPlaceholder,
    DateCircle,
    FlexBar,
    StandardSwitch,
  },
  mixins: [
    ProjectMixin,
    TaktPlanMixin,
    TrainMixin,
    TWaggonMixin,
    TaktAreaMixin,
    TWorkPackageMixin,
    FlexBarMixin,
    SideBarMixin,
    InfoBoxMixin,
    SwitchMixin,
    MilestonesMixin,
  ],
  beforeRouteUpdate (to, from, next) {
    if (to.params.open_cloudprint) {
      this.project.trains.forEach(train_id => {
         this.$store.dispatch('UltraDev/updateUDObject', {
           url: [
             {trains: train_id}
           ],
           update: {
             closed: this.$store.state.Auth.cloudprint_cache.settings.trains_open.includes(train_id)?false:true
           }
         })
        })
    }
    next();
  },
  beforeRouteLeave(to, from, next) {
    this.leaveEditMode({project_id: this.project_id})
    next();
  },
  props: ['project_id', 'project', 'milestone_id', 'snackbar'],
  data: () => ({
    date: '',
    weekstart: '',
    test: false,
    show_calendar_edit: false,
    show_statistics: true,
    project_image: ''
  }),
  mounted(){
    let taktplan_container = document.getElementById('taktplan');
    let taktplan_zoom = getComputedStyle(document.body).getPropertyValue('--taktplan_zoom');
    let workpackage_width_string = getComputedStyle(document.body).getPropertyValue('--workpackage_width');
    let column_width = parseInt(workpackage_width_string.slice(0, -2)) + 8;
    if (this.getCurrentTaktIndex(this.project_id)) {
      taktplan_container.scrollLeft = this.getCurrentTaktIndex(this.project_id) * column_width * taktplan_zoom;
    }
  },
  // updated() {
  //   // console.log('taktplan updated');
  // },
  computed: {
    // ...mapGetters('View', [
    //   'getStatisticsHeightVariables',
    // ]),
    ...mapGetters('Autopilot', [
      'getAutopilots',
    ]),
    new_milestone() {
      return this.getNewMilestone(this.project_id);
    },
    milestone_selection() {
      return this.getMileStoneSelection({project_id: this.project_id, milestone_id: this.milestone_id});
    }
  },
  methods: {
    getSquareMeter(train, taktarea){
      if (train.closed) {
        // train
        let square_meters = 0;
        for (var i = 0; i < train.taktareas.length; i++) {
          square_meters += this.getTaktarea(train.taktareas[i]).square_meter;
        }
        return square_meters;
      } else {
        // taktarea
        return parseInt(taktarea.square_meter) !== 0 ? taktarea.square_meter:''
      }
    },
    addProjectImage(){
      let image_data = new FormData();
      image_data.append('image', this.$refs.project_image.files[0]);
      this.uploadProjectImage({
        project_id: this.$route.params.project_id,
        image: image_data
      })
    },
    ...mapActions('Project', [
      'uploadProjectImage'
    ]),
    // ...mapActions('View', [
    //   'setStatisticsHeightVariables'
    // ]),
    ...mapActions('Autopilot', [
      'clearAutopilots'
    ]),




  }
}
</script>
<style>
  .taktplan {
    position: absolute;
    width: calc(100% - 8px);
    transition: width 0s 200ms;
    will-change: width;
  }
  .grow-x-enter, .grow-x-leave-to {
    width: 0px;
  }
  .grow-x-enter-active, .grow-x-leave-active {
    overflow: hidden;
    transition: all 0.1s ease-in-out;
  }
  .grow-y-enter, .grow-y-leave-to {
    height: 0px;
  }
  .grow-y-enter-active, .grow-y-leave-active {
    overflow: hidden;
    transition: all 0.1s ease-in-out;
  }
  .slide-enter, .slide-leave-to {
    transform: translateX(300px);
  }
  .slide-enter-active, .slide-leave-active {
    transition: all 0.2s ease-in-out;
  }
  .sidebar-slide-up-enter, .sidebar-slide-up-leave-to {
    transform: translateY(100%);
  }
  .sidebar-slide-up-enter-active, .sidebar-slide-up-leave-active {
    transition: all 0.2s ease-in-out;
  }
  .zoom-translate-enter, .zoom-translate-leave-to {
    transform: translate(var(--waggon_offset_x), var(--waggon_offset_y)) scale(0, 0);
  }
  .zoom-translate-enter-active, .zoom-translate-leave-active {
    transition: all 0.2s ease-in-out;
  }
  .zoom-enter, .zoom-leave-to {
    transform: translate(2px, -3px) scale(0.3, 0.3);
  }
  .zoom-enter-active, .zoom-leave-active {
    transition: all 0.2s ease-in-out;
  }
  .snack-bar-slide-y-enter, .snack-bar-slide-y-leave-to {
    transform: translateY(100px)
  }
  .snack-bar-slide-y-enter-active, .snack-bar-slide-y-leave-active {
    transition: all 0.2s ease-in-out;
  }
</style>
